// Приложение выборщика.

import {h, render} from 'preact';
// import 'preact/devtools';
import Root from './Root';
import {getState, subscribe} from './Store/index';
import applyQueryString from './utils/applyQueryString';
import getUtmParameters from './utils/getUtmParameters';
import removeUtmParameters from './utils/removeUtmParameters';
import {setUtmParameters} from './utils/updateAddress';

/**
 * Приложение выборщика.
 */
async function main(): Promise<void>
{
	const main = document.querySelector( 'main' ) as HTMLElement;
	
	if (
		!main
		|| !main.parentElement
	)
	{
		return;
	}
	
	let oldLoading: boolean = false;
	
	subscribe(
		() =>
		{
			const state = getState();
			const loading = state.common.loading;
			
			if ( loading === oldLoading )
			{
				return;
			}
			
			oldLoading = loading;
			
			if ( loading )
			{
				document.body.classList.add( 'loading' );
			}
			else
			{
				document.body.classList.remove( 'loading' );
			}
		},
	);
	
	setUtmParameters( getUtmParameters().join( '&' ) );
	await applyQueryString( removeUtmParameters( window.location.search ) );
	render( <Root />, main.parentElement, main );
}

/**
 * Module
 */
export {
	main as default,
};



// WEBPACK FOOTER //
// ./app/Routes/Choose/App/index.tsx